<template>
<div id="post">
    <header>
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Posten</h1>
    </header>
    <custom-form :fields="[ { name: 'message', type: 'textarea', title: 'Dein Post' }, 'photos' ]"
                 @submitted="onPosted"
                 clearOnSubmit
                 submitLabel="Posten"
                 url="timeline/post" />
</div>
</template>

<script>
import base from 'base.vue'
import customForm from 'components/custom-form.vue'

export default {
    mixins: [ base ],
    components: { customForm },
    data () {
        return { }
    },
    methods: {
        onPosted () {
            this.$router.push('/')
        }
    }
}
</script>



// WEBPACK FOOTER //
// post.vue?f2a60734